export const getSavingsOpportunitiesFixedCacheKey = (resourceId?: string) => {
  return `postOrganisationsCurrentSavingsOpportunities-fixed-cache-key-${resourceId}`;
};
